// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5970be7e","551":"020a8ef2","842":"34ccb7f7"}[chunkId] + ".chunk.js";
};